const React = require('react');
const Demo = require('../base-live-demo-component');
const componentCodeFront = require('./componentCodeFront');
const View = require('./componentView');

const { useEffect } = React;
const componentProps = require('./componentProps');

const BricksComponent = ({ i18n, deviceType, lang, userData, platform, liveDemoId, email, actualUrl }) => {
  const customHook = ({ styleProperties, setFormData }) => {
    useEffect(() => {
      const customInputErrors = {
        styleProperties: false,
      };

      try {
        JSON.parse(styleProperties);
      } catch {
        customInputErrors.styleProperties = {
          hasError: true,
          message: i18n.gettext('Revisa el formato de la configuración'),
        };
      }

      setFormData(prev => ({
        ...prev,
        customErrors: { ...customInputErrors },
      }));
    }, [styleProperties]);
  };

  return (<Demo
    customHook={customHook}
    componentDemo={View}
    componentSnippetFront={componentCodeFront}
    componentProps={componentProps.getProps(i18n, lang)}
    deviceType={deviceType}
    i18n={i18n}
    lang={lang}
    email={email}
    actualUrl={actualUrl}
    userData={userData}
    platform={platform}
    liveDemoId={liveDemoId}
  />);
};
module.exports = BricksComponent;
